export default {"src":"/_next/static/media/upload-document-icon.40b022b9.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};